import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';

import useStyles from './styles';

function TemplatesSkeleton() {
  const colorScheme = useColorScheme();
  const styles = useStyles({ colorScheme });
  const gridItems = [...Array(18)].map((_, index) => (
    <i className="skeleton" key={`${index}_skeleton`} />
  ));
  return (
    <div className={styles.root}>
      <HorizontalContainer>
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonGrid}>{gridItems}</div>
      </HorizontalContainer>
    </div>
  );
}

export default TemplatesSkeleton;
